// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"_2s99Ri6VVK9TkV8cUnVjjW","block":"T67n1ifG1TXUCWW2kL06t","blockName":"_3mgTLuVCnqEEL0i9VI6lP0","blockValue":"_2dGjk61yTcfJQRHMcuXx4h"};